import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import { motion } from "framer-motion";
import AnimatedTextButton from "./AnimatedTextButton";

const TitleDescriptionCard = ({ title, description, icon, learnMore }) => {
  return (
    <Container>
      <Line>
        {icon && <IconWrapper>{icon}</IconWrapper>}
        <Title>{title}</Title>
      </Line>
      <Description>{description}</Description>
      {learnMore && (
        <AnimatedTextButton
          style={{
            paddingTop: "10px",
            fontSize: "18px",
            fontWeight: "700",
            borderBottom: `1px solid ${lightThemeColors.darkColor}`,
          }}
          onClick={learnMore}
          text={"See More"}
        />
      )}
    </Container>
  );
};

export default TitleDescriptionCard;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(237, 235, 234, 1);
  border-radius: 10px;
  padding: 20px;
  overflow: hidden;
  @media (max-width: 990px) {
    padding: 10px;
  }
`;
const Title = styled.h2`
  color: ${lightThemeColors.darkColor};
  font-weight: 700;
  font-size: 20px;
  line-height: 34px;
  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 24px;
  }
`;
const Description = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  @media (max-width: 990px) {
    font-size: 14px;
    line-height: 28px;
  }
`;
const Line = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  min-width: 24px;
`;
